import React from "react";

import { IActiveLearningLesson } from "../../../state";
import ActiveLearningProjectionSidebar from "../../../molecules/teacher/ActiveLearningProjectionSidebar";

import ProjectionSlider from "./ProjectionSlider";
import styles from "./ActiveLearningProjection.module.scss";

export interface Props {
  lesson: IActiveLearningLesson | null;
  prevLessonId: number | null;
  nextLessonId: number | null;
  onChangeLesson: (lessonId: number) => void;
}

const ActiveLearningProjection: React.FC<Props> = ({
  lesson,
  prevLessonId,
  nextLessonId,
  onChangeLesson,
}) => {
  return (
    <div className={styles.wrapper}>
      <ProjectionSlider lesson={lesson} />
      <ActiveLearningProjectionSidebar
        lesson={lesson}
        prevLessonId={prevLessonId}
        nextLessonId={nextLessonId}
        onChangeLesson={onChangeLesson}
      />
    </div>
  );
};

export default ActiveLearningProjection;
